import Form from "../../Components/Form"
import React, { useState } from "react";
import TextInput from "../../Components/Form/TextInput"
import Text from "../../Components/Text"
import User from "../../APIController/User";

const UserActivation = () => {
    const [code, setCode] = useState("")
    const { approve } = User()

    const handleActivateUser = async (e) => {
        e.preventDefault();
        await approve(code);
        window.location.reload();
    };

    return (
        <Form onSubmitAction={handleActivateUser} submitButtonText={"Email bestätigen"}>
            <Text type="maintitle">Email wurde noch nicht bestätigt!</Text>
            <Text type="maintitle">Den Code findest du in deiner E-Mail – einfach hier eingeben und los geht’s!</Text>
            <TextInput attribute={code} placeholder={"E-Mail Code"} action={(e) => setCode(e.target.value)} />
        </Form>
    )
}

export default UserActivation